import { EventTypes } from '@candulabs/craft';

import { SET_COLLECTION_ITEM_EVENTS } from './constants';

export const setCollectionItemEvents = (eventType: EventTypes, collectionItemId?: string) => ({
  type: SET_COLLECTION_ITEM_EVENTS,
  eventType,
  collectionItemId,
});
